module.exports = "/_next/static/images/eddie-tang-7c507d99e6a77d5fc7fdbc0a55c6be86.jpg";